function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeDasharray: "1 1"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5,
  cy: 6.5,
  rx: 11.5,
  ry: 6.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.5,
  cy: 6.5,
  rx: 11,
  ry: 6
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 5h3v3h-3z"
});
function SvgCentroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 13,
    viewBox: "0 0 23 13"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='23' height='13' viewBox='0 0 23 13'%3e %3cg%3e %3cg fill='none' stroke='%23fff' stroke-dasharray='1 1' transform='translate(.001) translate(-.001)'%3e %3cellipse cx='11.5' cy='6.5' stroke='none' rx='11.5' ry='6.5'/%3e %3cellipse cx='11.5' cy='6.5' rx='11' ry='6'/%3e %3c/g%3e %3cpath fill='%23fff' d='M0 0H3V3H0z' transform='translate(.001) translate(9.999 5)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgCentroid as ReactComponent };